
import { defineComponent } from 'vue';
import useCapabilities from '@/resources/capabilities';
import api from '@/api';
import Expedient from '@/api/objects/Expedient';
import VLoader from '@/components/vendor/VLoader.vue';

export default defineComponent({
  name: 'TheProfessionalHomeExpedients',
  components: {
    VLoader,
  },
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  data() {
    return {
      expedients: [] as Expedient[],
      status: 'loading',
    };
  },
  async mounted() {
    await this.loadConsultations();
  },
  methods: {
    async loadConsultations() {
      try {
        this.expedients = await api.professional.expedient.all(null, false);

        this.status = 'loaded';
      } catch (e) {
        this.$toast.error(this.$t('Ha ocurrido un error al cargar las consultas'));
      }
    },
  },
});
